module.exports = __webpack_public_path__ + "media/images/lb/536-e2032722deb4660c56b42e18cb142f3d.svg";